import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import BootstrapVue from 'bootstrap-vue'
import VueIziToast from 'vue-izitoast'
import 'izitoast/dist/css/iziToast.css'
import '@fortawesome/fontawesome-pro/scss/fontawesome.scss'
import '@fortawesome/fontawesome-pro/scss/solid.scss'
import '@fortawesome/fontawesome-pro/scss/regular.scss'
import '@fortawesome/fontawesome-pro/scss/brands.scss'
import MainPage from './layout/main-page'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

/* eslint no-unused-vars: off */
import * as filters from './vue-global';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'animate.css'
import VueMoment from 'vue-moment'
import VueSwal from 'vue-swal'

import EInput from '../vue-components/components/e-input'
import EInputBirthday from '../vue-components/components/e-input-birthday.vue'

import { loadProgressBar } from 'axios-progress-bar'
import 'axios-progress-bar/dist/nprogress.css'

loadProgressBar();

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueIziToast, {
    balloon: true,
    position: `bottomRight`
});

Vue.use(VueMoment);
Vue.use(VueSwal);

Vue.component(`main-page`, MainPage);
Vue.component(`vue-multiselect`, VueMultiselect);
Vue.component(`vue-datetime-picker`, VueCtkDateTimePicker);
Vue.component(`vue-phone-input`, VuePhoneNumberInput);
Vue.component(`e-input`, EInput);
Vue.component(`e-input-birthday`, EInputBirthday);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount(`#app`);
